import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors } from "@clockwise/web-commons/src/styles/color.styles";
export { eventDateRow, metaInfo, eventDate } from "../SuggestionBody.styles";
import { baseBody, eventDateIcon } from "../SuggestionBody.styles";

export const container: CSSProperties = {
  ...baseBody,
  width: "100%",
};

export const warningIcon = {
  ...eventDateIcon,
  htmlColor: colors.red.bright,
};

export const conflictRow: CSSProperties = {
  display: "flex",
  alignItems: "center",
  padding: "15px 0",
};

export const conflictIcon = {
  htmlColor: colors.red.bright,
  style: {
    height: 20,
    width: 20,
    marginLeft: -2,
    marginRight: 5,
  } as CSSProperties,
};

export const conflictText: CSSProperties = {
  color: colors.red.bright,
  fontSize: 12,
  fontWeight: "bold",
  textTransform: "uppercase",
};
